import { ReactNode } from 'react'
import { Grid, useTheme, useMediaQuery } from '@mui/material'
import { css } from '@emotion/css'

interface IProps {
  children: ReactNode
}

export const AuthContentWrapper = ({ children }: IProps) => {
  const theme = useTheme()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile_s'))

  return (
    <Grid
      container
      display="flex"
      direction="row"
      height={'100vh'}
      style={{
        overflowY: isLaptop ? 'auto' : 'hidden',
      }}
      className={css(
        isLaptop && `width: 500px; margin: auto;`,
        isTablet && `width: 100%;`,
        isMobile && `width: 100vw;`,
      )}
    >
      {children}
    </Grid>
  )
}
